export const CATEGORIES = [
  "Clothing",
  "Jewelry",
  "Accessories",
  "Beauty & Skincare",
  "Hair & Wigs",
  "Home & Candles",
  "Gifts",
];
